import PropTypes from 'prop-types';

const componentDetail = {
  label: 'Payment Amount Input - Predefined',
  value: 'AmountInputPredefined',
};
const builderConfig = {
  general: {
    label: {
      type: 'string',
      required: true,
      max: { max: 30, message: `Max length is 30` },
    },
    hint: {
      type: 'string',
      required: false,
      max: { max: 60, message: `Max length is 60` },
    },
    'predefined Value 1': {
      type: 'number',
      required: true,
    },
    'predefined Value 2': {
      type: 'number',
      required: true,
    },
    'predefined Value 3': {
      type: 'number',
      required: true,
    },
    'predefined Value 4': {
      type: 'number',
      required: true,
    },
  },
};

const propTypes = {
  label: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  'predefined Value 1': PropTypes.string.isRequired,
  'predefined Value 2': PropTypes.string.isRequired,
  'predefined Value 3': PropTypes.string.isRequired,
  'predefined Value 4': PropTypes.string.isRequired,
  input: PropTypes.object,
};

const defaultProps = {
  label: 'Label',
  hint: window.isBizCentral ? 'Hint' : '',
  'predefined Value 1': '0',
  'predefined Value 2': '0',
  'predefined Value 3': '0',
  'predefined Value 4': '0',
};

export default { componentDetail, builderConfig, propTypes, defaultProps };
